import { render, staticRenderFns } from "./iconTemplate.vue?vue&type=template&id=18dd7246"
import script from "./iconTemplate.vue?vue&type=script&lang=js"
export * from "./iconTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports